import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Section,
  ContentWrapper,
  LeftPhone,
  RightPhone,
  ButtonLink,
  AppleFooterButton,
  GoogleFooterButton,
  ButtonsWrapper,
  MiddleWrapper,
  PreTitle,
  Link,
  TitleMain,
  DescriptionMain,
  FlexColCentr,
  FlexColCentrPad,
} from './Main.styled';
import leftPhone from '../../assets/images/LeftPhone4X.webp';
import rightPhone from '../../assets/images/RightPhone4X.webp';
import apple from '../../assets/images/buttons/appleMain.svg';
import google from '../../assets/images/buttons/googleMain.svg';

export const Main = () => {
  const width =
    typeof window !== 'undefined' ? window.innerWidth : 0;
  const isMobile = width < 768;

  const { t } = useTranslation();

  return (
    <Section>
      <ContentWrapper>
        {!isMobile ? (
          <LeftPhone src={leftPhone} alt='iphone' />
        ) : null}
        <MiddleWrapper>
          <FlexColCentr>
            <PreTitle>{t('pretitle')}</PreTitle>
            <TitleMain>{t('titleMain')}</TitleMain>
            <FlexColCentrPad>
              <DescriptionMain>
                {t('mainDescription')}
                <Link
                  href='https://u24.gov.ua/'
                  target='_blank'
                  rel='noreferrer'>
                  {t('united24')}
                </Link>
                {t('win')}
              </DescriptionMain>
            </FlexColCentrPad>
          </FlexColCentr>
          <ButtonsWrapper>
            {isMobile ? (
              <LeftPhone src={leftPhone} alt='iphone' />
            ) : null}
            <ButtonLink
              href='https://apps.apple.com/us/app/vidify-%D1%81%D1%83%D1%87%D0%B0%D1%81%D0%BD%D1%96-%D0%BE%D0%B3%D0%BE%D0%BB%D0%BE%D1%88%D0%B5%D0%BD%D0%BD%D1%8F/id1608800491'
              target='_blank'
              rel='noreferrer'>
              <AppleFooterButton
                src={apple}
                alt='apple footer'
              />
            </ButtonLink>
            <ButtonLink
              href='https://play.google.com/store/apps/details?id=com.online.vdf'
              target='_blank'
              rel='noreferrer'>
              <GoogleFooterButton
                src={google}
                alt='google footer'
              />
            </ButtonLink>
            {isMobile ? (
              <RightPhone src={rightPhone} alt='iphone' />
            ) : null}
          </ButtonsWrapper>
        </MiddleWrapper>
        {!isMobile ? (
          <RightPhone src={rightPhone} alt='iphone' />
        ) : null}
      </ContentWrapper>
    </Section>
  );
};
